import { ref, onMounted, onUnmounted, watchEffect, type Ref } from 'vue'
import { getScrollParent } from 'widget-components/utilities/get-scroll-parent'

export const useSpaceAvailability = (targetEl: Ref<Element | null>) => {
    const spaceToTop = ref(0)
    const spaceToBottom = ref(0)

    let container: Element | null = null
    let target: Element | null = null

    const containerRect = ref<DOMRect>()
    const targetRect = ref<DOMRect>()

    const update = () => {
        target = targetEl.value
        container = target ? getScrollParent(target) ?? document.body : null

        if (!target || !container) {
            return
        }

        containerRect.value = container.getBoundingClientRect()
        targetRect.value = target.getBoundingClientRect()

        spaceToTop.value = targetRect.value.top - containerRect.value.top
        spaceToBottom.value = containerRect.value.bottom - targetRect.value.bottom
    }

    let resizeObserver: ResizeObserver | null = null

    onMounted(() => {
        update()

        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(update)
            target && resizeObserver.observe(target)
            container && resizeObserver.observe(container)
        }

        window.addEventListener('resize', update)
        container?.addEventListener('scroll', update, { passive: true })
    })

    onUnmounted(() => {
        window.removeEventListener('resize', update)
        container?.removeEventListener('scroll', update)

        if (resizeObserver) {
            target && resizeObserver.unobserve(target)
            container && resizeObserver.unobserve(container)
            resizeObserver.disconnect()
        }
    })

    watchEffect(update)

    return {
        spaceToTop,
        spaceToBottom,
        targetRect,
        containerRect,
    }
}
